module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-image-root"
  }, [(_vm.canShowRipple) ? _c('svg', {
    staticClass: "svg-filters",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "filter-ripple"
    }
  }, [_c('feImage', {
    attrs: {
      "xlink:href": "../static/images/ripple.png",
      "x": "30",
      "y": "20",
      "width": "0",
      "height": "0",
      "result": "ripple"
    }
  }), _vm._v(" "), _c('feDisplacementMap', {
    attrs: {
      "xChannelSelector": "R",
      "yChannelSelector": "G",
      "color-interpolation-filters": "sRGB",
      "in": "SourceGraphic",
      "in2": "ripple",
      "scale": "20",
      "result": "dm"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "in",
      "in2": "ripple"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceGraphic"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "header-image-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-image",
    on: {
      "mouseenter": _vm.showSvgRipple,
      "mousedown": _vm.showSvgRipple
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/header-image2.jpg"),
      "alt": "header-image",
      "width": "100%",
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59770d84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-image/header-image.vue
// module id = 187
// module chunks = 0